// Theme selection. 'system' leaves the root unstamped so the CSS media query wins;
// an explicit choice stamps data-theme, which the token blocks are written to beat
// in both directions.

export type Theme = 'system' | 'light' | 'dark';

const KEY = 'healthlab.theme';

export function getTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    // Private windows and blocked site data both throw here; a missing preference
    // is not an error, it just means "follow the device".
    return 'system';
  }
}

export function setTheme(theme: Theme): void {
  try {
    if (theme === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch { /* preference simply will not persist */ }
  applyTheme(theme);
}

export function applyTheme(theme: Theme = getTheme()): void {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}
